import { get, post, patch, del } from '../httpMethods';
import { ApiResponse } from '../../types/api';

export interface Specialization {
  id: string;
  name: string;
  label: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSpecializationPayload {
  name: string;
  label: string;
  description?: string;
  isActive?: boolean;
}

export const specializationService = {
  getSpecializations: (page = 1, limit = 20, search?: string): Promise<ApiResponse<Specialization[]>> => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (search) params.set('search', search);
    return get<Specialization[]>(`/specializations?${params.toString()}`);
  },

  getAllSpecializations: (): Promise<ApiResponse<Specialization[]>> => {
    return get<Specialization[]>('/specializations?limit=1000');
  },

  getActiveSpecializations: (): Promise<ApiResponse<Specialization[]>> => {
    return get<Specialization[]>('/specializations?active=true');
  },

  createSpecialization: (data: CreateSpecializationPayload): Promise<ApiResponse<Specialization>> => {
    return post<Specialization>('/specializations', data);
  },

  updateSpecialization: (id: string, data: Partial<CreateSpecializationPayload>): Promise<ApiResponse<Specialization>> => {
    return patch<Specialization>(`/specializations/${id}`, data);
  },

  deleteSpecialization: (id: string): Promise<ApiResponse<void>> => {
    return del<void>(`/specializations/${id}`);
  },
};
